'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CameraOutlined = _interopRequireDefault(require('./lib/icons/CameraOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CameraOutlined;
exports.default = _default;
module.exports = _default;